import React, {Component} from "react";

class NewsStory extends Component {
    render () {
        let {title, content} = this.props;

        // content = content.replace(/\n/g, "<br />");

        return (
            <div className='news_story'>
                <div className='news_story_title'>{title}</div>
                <div className='news_story_content' dangerouslySetInnerHTML={{__html: content}}></div>
            </div>
        )
    }
}

export default NewsStory;


// WEBPACK FOOTER //
// ./src/components/containers/play-screen/news-feed/news-story.js